import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { AuthContextProvider } from './context/AuthContext';

function App() {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <div className="bg-background min-h-screen font-paragraph text-textPrimary">
          <AppRoutes />
        </div>
      </BrowserRouter>
    </AuthContextProvider>
  );
}

export default App;
